import { CanActivateFn } from '@angular/router';
import { dashboardGuestGuard, dashboardRoleGuard } from 'sham-components/services';

export const driverAdminGuard: CanActivateFn = dashboardRoleGuard('DriverAdmin', [
  '/login',
]);

export const guestGuard: CanActivateFn = dashboardGuestGuard('DriverAdmin', [
  '/app/drivers',
]);
